function initAliCaptcha(callback) {
  window.AliyunCaptchaConfig = {
    region: 'sgp',
    prefix: '1u3wto'
  };
  let language = navigator.language || navigator.userLanguage || 'en';
  if (language.includes('-')) {
    [language] = language.split('-');
  }
  const scriptId = 'lm-captcha-script';
  const captchaElementId = 'lm-captcha-element';
  const buttonId = 'lm-captcha-button';
  const sdkType = 'aliyun';

  function initCaptcha() {
    window.initAliyunCaptcha({
      SceneId: '72tf5f1t',
      mode: 'popup',
      element: `#${captchaElementId}`,
      button: `#${buttonId}`,
      success(captchaVerifyParam) {
        callback({
          data: captchaVerifyParam,
          sdk_type: sdkType
        });
      },
      fail(result) {
        console.error(result);
      },
      getInstance(instance) {
        console.log('getInstance', instance);
        window.captchaInstance = instance;
        window.captchaInstance.show();
      },
      onClose() {
        callback({
          data: '',
          sdk_type: sdkType
        });
      },
      language,
      slideStyle: {
        width: 360,
        height: 40
      }
    });
  }

  if (!window.captchaInstance) {
    const captchaElement = document.createElement('div');
    captchaElement.id = captchaElementId;
    document.body.appendChild(captchaElement);

    const button = document.createElement('button');
    button.id = buttonId;
    button.style.display = 'none';
    document.body.appendChild(button);

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js';
    document.body.appendChild(script);

    script.onload = () => {
      initCaptcha();
    };
  } else {
    window.captchaInstance.show();
  }
}
export default initAliCaptcha;
